module.exports = __webpack_public_path__ + "img/ic-play.3a77cb73.svg";